<template>
  <div class="update-user-password-details">
    <el-alert
      v-if="unhandledErrorMessage"
      :title="unhandledErrorMessage"
      type="error"
      @close="handleAlertClose"
    ></el-alert>
    <er-form
      ref="updatePasswordForm"
      label-position="left"
      label-width="10em"
      v-loading="loading"
      :model="formData"
      size="mini"
      @submit.prevent="sumbitUpdatePasswordDetails"
    >
      <el-row class="details-section">
        <er-form-item
          prop="current_password"
          :label="userFormLabels[0].label"
          :error="castErrorKeyToLang(errMessagesObject.current_password)"
        >
          <er-input
            v-model="formData.current_password"
            class="input-box"
            :placeholder="userFormLabels[0].placeholder"
            show-password
          >
            <!-- <template slot="prepend">
              <img class="img-icon" src="@/assets/password.svg" />
            </template>-->
          </er-input>
        </er-form-item>
        <er-form-item
          prop="new_password"
          :label="userFormLabels[1].label"
          :error="castErrorKeyToLang(errMessagesObject.password)"
        >
          <er-input
            v-model="formData.password"
            class="input-box"
            :placeholder="userFormLabels[1].placeholder"
            show-password
          >
            <!-- <template slot="prepend">
              <img class="img-icon" src="@/assets/password.svg" />
            </template>-->
          </er-input>
        </er-form-item>
        <er-form-item
          prop="confirm_password"
          :label="userFormLabels[2].label"
          :error="castErrorKeyToLang(errMessagesObject.confirm_password)"
        >
          <er-input
            v-model="formData.confirm_password"
            class="input-box"
            :placeholder="userFormLabels[2].placeholder"
            @keyup.native.enter="sumbitUpdatePasswordDetails"
            show-password
          >
            <!-- <template slot="prepend">
              <img class="img-icon" src="@/assets/password.svg" />
            </template>-->
          </er-input>
        </er-form-item>
      </el-row>

      <el-row type="flex" justify="end" class="btn-action-container">
        <el-col :span="8" style="display: flex; justify-content: flex-end;">
          <er-action-button
            :type="'save'"
            :disabled="isReadOnly"
            :bgColor="'#33A02C'"
            @action-btn-click="sumbitUpdatePasswordDetails"
          >
            <template v-slot:icon>
              <img src="@/assets/ticks.svg" />
            </template>
            <template v-slot:label>
              <p style="color: white; margin-right: 4px;">
                {{ $t("Comn_save") }}
              </p>
            </template>
          </er-action-button>
          <div style="margin-left: 8px;">
            <er-action-button
              @action-btn-click="resetForm"
              :type="'cancel'"
              :disabled="isReadOnly"
            >
              <template v-slot:label>
                <p style="color: black">{{ `${$t("Comn_cancel")}` }}</p>
              </template>
              <!-- <i class="el-icon-error"></i> -->
            </er-action-button>
          </div>
        </el-col>
      </el-row>
    </er-form>
  </div>
</template>
<script>
import errorHandlerMixin from "@/mixins/errorHandlerMixin.js";
import errorKeyMapMixin from "@/mixins/errorKeyMapMixin";

import {
  erFormItem,
  erForm,
  erInput,
  erButton
} from "@/components/base/basePondlogs";
export default {
  mixins: [errorHandlerMixin, errorKeyMapMixin],
  components: {
    erFormItem,
    erForm,
    erInput,
    erButton
  },
  props: ["user_details"],
  data: function() {
    return {
      formData: {
        current_password: "",
        password: "",
        confirm_password: ""
      },
      errMessagesObject: {
        current_password: "",
        password: "",
        confirm_password: ""
      },
      userFormLabels: [],
      loading: false
    };
  },
  created() {
    //  this.formData.current_password = this.$store.getters['user/getUserProfile'].password
    this.userFormLabels = [
      {
        label: this.$t("Usrs_old_password"),
        placeholder: this.$t("Usrs_enter_old_pwd")
      },
      {
        label: this.$t("Comn_new_password"),
        placeholder: this.$t("Usrs_enter_new_pwd")
      },
      {
        label: this.$t("Comn_confirm_pwd"),
        placeholder: this.$t("Usrs_enter_confirm_pwd")
      }
    ];
  },
  computed: {
    isReadOnly() {
      return this.$store.getters["user/isReadOnly"];
    }
  },
  methods: {
    resetForm() {
      this.formData = {
        current_password: "",
        password: "",
        confirm_password: ""
      };
      this.errMessagesObject = {
        current_password: "",
        password: "",
        confirm_password: ""
      };
      this.$emit("close");
    },
    sumbitUpdatePasswordDetails() {
      // console.log("entered")
      // this.$refs.forgotPasswordForm.clearValidate()
      this.loading = true;
      this.errMessagesObject = {
        current_password: "",
        password: "",
        confirm_password: ""
      };
      this.$store
        .dispatch("user/updatePasswordSubUser", {
          userId: this.user_details._id,
          payload: this.formData
        })
        .then(response => {
          this.$notify({
            title: this.$t("Usrs_success_msg"),
            message: this.$t("Usrs_pwd_upd_success"),
            duration: 5000,
            type: "success"
          });
          this.$emit("close", "success");
        })
        .catch(err => {
          this.errorMessages(err, true);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.update-user-password-details {
  .er-button {
    width: 7rem;
  }
  .details-section {
    padding-left: 40px;
    padding-right: 40px;
    .el-form-item__label {
      @include responsiveProperty(
        font-size,
        $app_font_size_small,
        $app_font_size_1,
        $app_font_size_2,
        true
      );
    }
  }

  .btn-action-container {
    display: flex;
    justify-content: flex-start;
    padding-top: 20px;
    border-top: 1px solid rgb(221, 221, 221);
    border-right: 1px solid rgb(221, 221, 221);
  }

  .el-input--mini {
    font-size: 11px !important;
    width: 279px !important;
  }
  .el-input__inner {
    text-align: left !important;
  }
  .er-form-item .el-form-item__error {
    padding-left: 0px;
  }
}
</style>
